import { useEffect } from 'react';
import { ArrowLeft, Cookie } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const CookiePolicyPage = () => {
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const reopenBanner = () => {
    try {
      localStorage.removeItem('taj_cookie_consent');
    } catch {}
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7]" data-testid="cookie-policy-page">
      <header className="sticky top-0 z-50 glass border-b border-[#2D231E]/10">
        <div className="container-max flex items-center h-16">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-[#5C4D43] hover:text-[#C44536] transition-colors"
            data-testid="back-from-cookies"
          >
            <ArrowLeft className="w-5 h-5" />
            <span className="font-sans text-sm font-medium">Volver</span>
          </button>
        </div>
      </header>

      <div className="container-max py-12 max-w-4xl">
        <div className="flex items-center gap-3 mb-8">
          <Cookie className="w-8 h-8 text-[#C44536]" />
          <h1 className="font-serif text-3xl md:text-4xl font-bold text-[#2D231E]">Politica de Cookies</h1>
        </div>

        <div className="prose prose-lg font-sans text-[#2D231E] space-y-6">
          <p className="text-[#5C4D43] text-sm">Ultima actualizacion: Abril 2026</p>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">1. ¿Que son las Cookies?</h2>
            <p className="text-[#5C4D43] leading-relaxed">
              Una cookie es un pequeño fichero de texto que un sitio web almacena en el navegador del Usuario
              al visitarlo. Las cookies permiten al sitio web recordar informacion sobre la visita (idioma
              preferido, contenido del carrito, sesion iniciada) para ofrecer una mejor experiencia al volver.
            </p>
            <p className="text-[#5C4D43] leading-relaxed mt-3">
              Esta Politica de Cookies se ajusta a lo dispuesto en el articulo 22.2 de la Ley 34/2002
              (LSSI-CE), el Reglamento (UE) 2016/679 (RGPD) y las guias de la Agencia Española de Proteccion
              de Datos (AEPD).
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">2. Cookies que Utilizamos</h2>
            <p className="text-[#5C4D43] leading-relaxed mb-4">
              En <strong>www.tajmahalsanfernando.es</strong> utilizamos exclusivamente cookies tecnicas
              estrictamente necesarias para el funcionamiento del sitio web. <strong>No utilizamos cookies
              publicitarias, de analitica ni de seguimiento de terceros</strong>.
            </p>
            <div className="overflow-x-auto">
              <table className="w-full text-sm border border-[#E8DEC8] rounded-lg overflow-hidden">
                <thead className="bg-[#FDFBF7]">
                  <tr>
                    <th className="text-left p-3 border-b border-[#E8DEC8]">Nombre</th>
                    <th className="text-left p-3 border-b border-[#E8DEC8]">Tipo</th>
                    <th className="text-left p-3 border-b border-[#E8DEC8]">Finalidad</th>
                    <th className="text-left p-3 border-b border-[#E8DEC8]">Duracion</th>
                  </tr>
                </thead>
                <tbody className="text-[#5C4D43]">
                  <tr>
                    <td className="p-3 border-b border-[#E8DEC8]"><code>taj_cookie_consent</code></td>
                    <td className="p-3 border-b border-[#E8DEC8]">Tecnica</td>
                    <td className="p-3 border-b border-[#E8DEC8]">Recordar el consentimiento del aviso de cookies</td>
                    <td className="p-3 border-b border-[#E8DEC8]">12 meses</td>
                  </tr>
                  <tr>
                    <td className="p-3 border-b border-[#E8DEC8]"><code>taj_cart_id</code></td>
                    <td className="p-3 border-b border-[#E8DEC8]">Tecnica</td>
                    <td className="p-3 border-b border-[#E8DEC8]">Mantener el contenido del carrito de compra</td>
                    <td className="p-3 border-b border-[#E8DEC8]">Sesion</td>
                  </tr>
                  <tr>
                    <td className="p-3 border-b border-[#E8DEC8]"><code>taj_language</code></td>
                    <td className="p-3 border-b border-[#E8DEC8]">Tecnica</td>
                    <td className="p-3 border-b border-[#E8DEC8]">Recordar el idioma seleccionado (ES/EN)</td>
                    <td className="p-3 border-b border-[#E8DEC8]">12 meses</td>
                  </tr>
                  <tr>
                    <td className="p-3 border-b border-[#E8DEC8]"><code>access_token</code></td>
                    <td className="p-3 border-b border-[#E8DEC8]">Tecnica (admin)</td>
                    <td className="p-3 border-b border-[#E8DEC8]">Autenticacion del panel de administracion</td>
                    <td className="p-3 border-b border-[#E8DEC8]">24 horas</td>
                  </tr>
                  <tr>
                    <td className="p-3">Cookies de Stripe</td>
                    <td className="p-3">Terceros (tecnicas)</td>
                    <td className="p-3">Procesar pagos con tarjeta de forma segura (solo activas durante el pago)</td>
                    <td className="p-3">Segun Stripe</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-[#5C4D43] text-sm mt-4 italic">
              Las cookies tecnicas estan exentas del deber de consentimiento conforme al articulo 22.2 LSSI-CE
              al ser estrictamente necesarias para la prestacion del servicio.
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">3. Como Controlar las Cookies</h2>
            <p className="text-[#5C4D43] leading-relaxed">
              Puedes permitir, bloquear o eliminar las cookies instaladas en tu equipo mediante la configuracion
              de tu navegador. Ten en cuenta que, al tratarse de cookies estrictamente necesarias, bloquearlas
              puede impedir el correcto funcionamiento del sitio web (por ejemplo, no podras realizar pedidos).
            </p>
            <ul className="list-disc pl-6 text-[#5C4D43] mt-3 space-y-1">
              <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-[#C44536] underline">Google Chrome</a></li>
              <li><a href="https://support.mozilla.org/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank" rel="noopener noreferrer" className="text-[#C44536] underline">Mozilla Firefox</a></li>
              <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-[#C44536] underline">Safari</a></li>
              <li><a href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-[#C44536] underline">Microsoft Edge</a></li>
            </ul>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">4. Revocar el Consentimiento</h2>
            <p className="text-[#5C4D43] leading-relaxed mb-4">
              Puedes revocar tu consentimiento al aviso de cookies en cualquier momento. Al hacerlo, el banner
              de cookies se mostrara de nuevo para que puedas revisar tu decision.
            </p>
            <button
              onClick={reopenBanner}
              className="btn-primary px-5 py-2 text-sm"
              data-testid="reset-cookies-btn"
            >
              Revisar mis preferencias de cookies
            </button>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">5. Responsable</h2>
            <p className="text-[#5C4D43]">
              Talwinder Singh Kaur (empresaria autonoma) — Taj Mahal San Fernando<br />
              NIF: 78317925G<br />
              Calle Real 109, San Fernando, Cadiz 11100, España<br />
              Email: Tajmahalsafernando@gmail.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicyPage;
